// GET /api/firm/staff (server returns { staff: ResolvedStaff[] }). No
// fixture fallback: an unreachable server or a denied request throws, so
// callers render an honest error instead of a prototype team. The route
// is open to every authenticated staff role.

import { getAuthHeaders } from "./auth";

export interface FirmStaff {
  id: string;
  fullName: string;
  email: string;
  role: string;
  isPlaceholder?: boolean;
}

export async function fetchFirmStaff(): Promise<FirmStaff[]> {
  const res = await fetch("/api/firm/staff", {
    headers: { ...getAuthHeaders() },
    credentials: "same-origin",
  });
  if (!res.ok) throw new Error(`Staff list failed: ${res.status}`);
  const payload = (await res.json()) as { staff?: Array<Partial<FirmStaff>> };
  return (payload.staff ?? []).map<FirmStaff>((s) => ({
    id: String(s.id ?? ""),
    fullName: s.fullName ?? "",
    email: s.email ?? "",
    role: s.role ?? "staff",
    isPlaceholder: s.isPlaceholder,
  }));
}
